module.exports = __webpack_public_path__ + "static/media/backjava.f223b50f.jpg";